import { useEffect, useRef, useState } from "react";
import "./TriviaStatus.scss";

const TriviaStatus = (props) => {
    console.log('Trivia Status props: ', props);

    const featureVars = props.featureVars;
    const roundsCount = props?.customisationData?.setup?.triviaData?.triviaSetup?.[0]?.roundsCount ?? 1;
    let selectedRound = Number(featureVars.triviaControl?.selectedRound ?? props.passedInPreviewData?.triviaControl?.selectedRound ?? 0);
    if (isNaN(selectedRound) || selectedRound < 0 || selectedRound >= roundsCount || selectedRound == '') {
        selectedRound = 0;
    }

    const triviaData = props.customisationData?.setup?.['triviaData' + (selectedRound + 1)]?.questions;
    const roundSetup = (featureVars.triviaControl?.roundSetup && featureVars.triviaControl?.roundSetup !== '' ? featureVars.triviaControl?.roundSetup : props.passedInPreviewData?.triviaControl?.roundSetup) ?? null;
    const getRoundQuestionIndex = () => {
        if (roundSetup) {
            const currentRoundQuestionIndex = Number(featureVars.triviaControl?.currentRoundQuestionIndex ?? props.passedInPreviewData?.triviaControl?.currentRoundQuestionIndex ?? 0);
            return currentRoundQuestionIndex;
        }
        return 0;
    }
    const selectedTriviaIndex = getRoundQuestionIndex();
    const selectedTriviaData = triviaData?.[selectedTriviaIndex];
    let answers = [];
    for (let i = 0; i < 10; i++) {
        if (selectedTriviaData?.['answer' + (i + 1)]) {
            answers.push(selectedTriviaData['answer' + (i + 1)]);
        }
    }

    console.log('--- TriviaStatus, selectedTriviaData: ', selectedTriviaData, featureVars, props);

    const [forceUpdate, setForceUpdate] = useState(0);
    const forceUpdateNow = () => {
        setForceUpdate((val) => val + 1);
    }

    const findTriviaStateData = (triviaData_arg) => {
        if (!triviaData_arg) {
            return null;
        }
        let triviaStateData = null;
        console.log('--- TRIVIA_STATE, findTriviaStateData: ', props.previewControls, props.passedInPreviewData, selectedRound, roundsCount);
        if (props.previewControls && props.passedInPreviewData.triviaControl?.triviaState) {
            const triviaTitle = triviaData_arg.title;
            if (typeof props.passedInPreviewData.triviaControl.triviaState?.[selectedRound]?.length === 'number') {
                for (let i = 0; i < props.passedInPreviewData.triviaControl.triviaState?.[selectedRound]?.length; i++) {
                    if (props.passedInPreviewData.triviaControl.triviaState[selectedRound][i].triviaTitle === triviaTitle) {
                        triviaStateData = props.passedInPreviewData.triviaControl.triviaState[selectedRound][i];
                    }
                }
            }
        }
        if (triviaStateData === null && featureVars.triviaControl?.triviaState) {
            const triviaTitle = triviaData_arg.title;
            if (typeof featureVars.triviaControl.triviaState?.[selectedRound]?.length === 'number') {
                for (let i = 0; i < featureVars.triviaControl.triviaState?.[selectedRound]?.length; i++) {
                    if (featureVars.triviaControl.triviaState[selectedRound][i].triviaTitle === triviaTitle) {
                        triviaStateData = featureVars.triviaControl.triviaState[selectedRound][i];
                    }
                }
            }
        }
        if (triviaStateData === null) {
            if (typeof featureVars.triviaControl.triviaState === 'undefined' || featureVars.triviaControl.triviaState === null || !Array.isArray(featureVars.triviaControl.triviaState) || !Array.isArray(featureVars.triviaControl.triviaState?.[0])) {
                featureVars.triviaControl.triviaState = [];
            }
            while (featureVars.triviaControl.triviaState.length < roundsCount) {
                featureVars.triviaControl.triviaState.push([]);
            }
            triviaStateData = {
                triviaTitle: triviaData_arg.title,
                triviaRunning: false,
                answerState: []
            };

            console.log('--- TRIVIA_STATE, Initialising triviaStateData for: ', featureVars, triviaStateData, selectedRound, roundsCount);

            featureVars.triviaControl.triviaState[selectedRound].push(triviaStateData);
        }

        if (Array.isArray(triviaStateData.answerState) === false) {
            triviaStateData.answerState = [];
        }
        // Make sure we have state data for each answer
        // State data is in the following format:
        // {
        //     included: [boolean],
        //     correct: [boolean],
        //     votePercentage: [integer]
        // }
        // We can report the state back from the trivia to keep the votePercentage up to date, although prob only at the of voting start and end
        for (let i = 0; i < 10; i++) {
            if (triviaData_arg['answer' + (i + 1)] && triviaData_arg['answer' + (i + 1)] !== '') {
                if (typeof triviaStateData.answerState[i] === 'undefined') {
                    triviaStateData.answerState.push({
                        included: true,
                        correct: false,
                        votePercentage: 0
                    });
                }
            } else {
                // A blank / non existent answer means we don't have any more answers
                break;
            }
        }

        return triviaStateData;
    }

    const triviaStateData = findTriviaStateData(selectedTriviaData);
    const passedInPreviewData = props?.passedInPreviewData;
    const changeValFunc = props.changeValFunc;

    useEffect(() => {
        const varsToUse = passedInPreviewData ? passedInPreviewData : featureVars;
        if (varsToUse?.triviaControl?.triviaState?.[selectedRound]) {
            for (let i = 0; i < varsToUse.triviaControl.triviaState[selectedRound].length; i++) {
                const triviaStateData_i = varsToUse.triviaControl.triviaState[selectedRound][i];

                if (triviaStateData && triviaStateData_i && triviaStateData?.triviaTitle === triviaStateData_i.triviaTitle) {
                    let triviaHasVotes = false;
                    let correctAnswer = -1;
                    for (let i = 0; i < triviaStateData_i.answerState.length; i++) {
                        if (triviaStateData_i.answerState[i].votePercentage > 0) {
                            triviaHasVotes = true;
                        }
                    }

                    // make sure top level, ie. varsToUse.triviaControl.triviaHasVotes is updated
                    if (typeof triviaStateData.triviaHasVotes !== 'undefined' && triviaStateData.triviaHasVotes !== triviaHasVotes) {
                        // console.log('--- ANSWER_SELECTOR, Set triviaHasVotes to: ', triviaHasVotes);
                        setTimeout(() => changeValFunc('triviaControl', 'triviaHasVotes', triviaHasVotes, false, false, triviaStateData.correctAnswer !== correctAnswer ? false : true), 20);
                    }
                }
            }
        }
    }, [triviaStateData, featureVars, passedInPreviewData, changeValFunc]);

    let winningAnswerIndex = -1;
    let winningAnswerVotePercentage = 0;
    if (triviaStateData) {
        for (let i = 0; i < triviaStateData.answerState.length; i++) {
            if (triviaStateData.answerState[i].votePercentage > winningAnswerVotePercentage) {
                winningAnswerVotePercentage = triviaStateData.answerState[i].votePercentage;
                winningAnswerIndex = i;
            }
        }
    }

    const currentRound = featureVars.triviaControl?.selectedRound ?? props.passedInPreviewData?.triviaControl?.selectedRound ?? 0;
    const currentRoundQuestionIndex = featureVars.triviaControl?.currentRoundQuestionIndex ?? props.passedInPreviewData?.triviaControl?.currentRoundQuestionIndex ?? 0;

    return (
        <div className="fl-column live-trivia-answers-selector">
            {!triviaStateData &&
                <div className="form-field-content label">
                    Trivia Status Not Available
                </div>
            }
            {triviaStateData &&
                <>
                    <div className="form-field-content var-label">
                        Trivia Status
                    </div>
                    <div className="fl-column no-gap">
                        <div>Results will appear below after the voting ends.</div>
                        {triviaStateData.triviaRunning &&
                            <div className="trivia-running">Voting is currently active...</div>
                        }
                        {!triviaStateData.triviaRunning &&
                            <div className="trivia-not-running">Voting is not currently active.</div>
                        }
                    </div>
                    <div>Round <span className="bold-text">{Number(currentRound) + 1}</span>, Question <span className="bold-text">{Number(currentRoundQuestionIndex) + 1}</span></div>
                    <div><span className='question-text'>{selectedTriviaData.question}</span></div>
                    {answers.map((answer, index) => {
                        return (
                            <div className="fl-row compact" key={index}>
                                <div className={`grow answer-text ${selectedTriviaData.correctAnswer === 'answer' + (index + 1) ? 'correct-answer' : ''} ${answer.votePercentage > 0 && (index === winningAnswerIndex || answer.votePercentage === winningAnswerVotePercentage) ? 'winning-answer' : ''}`}>
                                    {selectedTriviaData['answer' + (index + 1)]}
                                </div>
                                <div className="shrink vote-percentage">
                                    {triviaStateData?.answerState?.[index]?.votePercentage ?? 0}%
                                </div>
                            </div>
                        )
                    })}
                </>
            }
        </div>
    )
}

export default TriviaStatus;
